import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { ORG_APIS } from "@/api_framework/api_config";

// A multi-select option as the membership extension screens log it
export interface IClickLogSelectedOption {
  id: string;
  name: string;
}

// A logged coupon, with its voucher family once one has been mapped to it
export interface IClickLogCouponVoucherMapping {
  coupon_id: string;
  coupon_name?: string;
  voucher_family_id?: string;
}

export interface IClickLogBody {
  event_type: string;
  event_action?: string;
  nudge_type?: any;
  scr_id?: string;
  timestamp?: number;
  user_id?: string;
  client_id?: string;
  pet_id?: string;
  pet_type?: any;
  vms_user_id?: string;
  filter_values?: any;
  number_of_slots?: number;
  prepaid_slots?: number;
  cta1?: string;
  cta2?: string;
  cta_text?: string;
  checkbox_text?: string;
  search_item?: string;
  emr_search_type?: string;
  clinic_id?: string;
  clinic_name?: string;
  search_result?: any;
  emr_id?: string;
  click_on_search_item?: any;
  recommended_tests?: any;
  lab_test_and_diagnostics?: any;
  medication_section?: any;
  treatments_section?: any;
  food_and_accessories?: any;
  cart_id?: any;
  emr_cart_items?: any;
  emr_cart_click_item?: any;
  nudge_name?: any;
  rota_id?: any;
  staff_id?: any;
  shift_id?: any;
  summary_id?: any;
  location_details?: any;
  search_tag?: any;
  address_id?: any;
  is_high_care?: boolean;
  crt_id?: string;
  agent_id?: string;
  customer_type?: string;
  source?: string;
  phone?: string;
  opened_at?: number;
  membership_id?: string;
  gift_id?: string;
  reference_id?: string;
  membership_details?: any;
  membership_tag?: string;
  membership_name?: string;
  number_of_talking_points?: number;
  talking_points_data?: any;
  TP_header?: string;
  TP_heading?: string;
  TP_action_click?: string;
  TP_summary_list?: string[];
  request_id?: string;
  request_number?: string;
  direction?: string;
  doctor_id?: string;
  items_count?: number;
  transfer_items?: any;
  vaccines?: any;
  vaccine_count?: number;
  mobile?: string;
  cms_page_slug?: string;
  cms_status?: string;
  cms_changed_fields?: any;
  cms_changed_field_count?: number;
  extension_id?: string;
  extension_name?: string;
  extension_category?: string;
  // Numeric while it comes from an API payload, string while it is still the
  // raw value held by the setup form input
  extension_amount?: number | string;
  extension_days?: number | string;
  extension_status?: string;
  extension_is_cart_search?: boolean;
  extension_sub_services?: string[] | IClickLogSelectedOption[];
  extension_connected_memberships?: string[] | IClickLogSelectedOption[];
  extension_coupons?: IClickLogCouponVoucherMapping[];
  voucher_family_id?: string;
  order_id?: string;
  amount?: number;
  invoice_id?: string;
  sub_order_id?: string;
  gift_card_qty?: number | null;
  booking_id?: string;
  attendance_date?: string;
  attendance_section?: string;
  alert_type?: string;
  reason_code?: string;
  nav_module_id?: string;
  nav_sub_module_id?: string;
  previous_clinic_id?: string;
  previous_clinic_name?: string;
  sub_service_id?: string | null;
  original_mobile?: string;
  mobile_edited?: boolean;
  whatsapp_sent?: boolean;
  sms_sent?: boolean;
  send_status?: "success" | "failed";
  failure_reason?: string;
}

AxiosCurlirize(axios, () => {});

export const useClickLogAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (logBody: IClickLogBody) => {
      try {
        const response: boolean = await axios
          .post(
            ORG_APIS?.CLICK_LOG_API?.baseURL ?? "",

            logBody,

            {
              headers: {
                "Content-Type": "application/json",
              },
            },
          )
          .then((res: AxiosResponse<{ status: boolean; message: string; data: any }>) => {
            if (res.data.status) {
              return true;
            } else {
              return false;
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            return false;
          });
        return response;
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
        return false;
      }
    },
    [dispatch],
  );
  return { execute };
};
